import React, { useState } from 'react'
import { useQuickBooksApi } from 'apps/fleet-planner/hooks'

export const QuickBooksConnect = () => {
  const { getQuickBooksGrantUrl } = useQuickBooksApi()
  const [quickBooksGrantUrl, setQuickBooksGrantUrl] = useState<string>('')
  const generateQuickBooksGrantUrl = async () => {
    setQuickBooksGrantUrl(await getQuickBooksGrantUrl())
  }
  return (
    <div className='mv2'>
      <button
        onClick={generateQuickBooksGrantUrl}
        onKeyPress={generateQuickBooksGrantUrl}
        role='link'>
        Generate QuickBooks Grant url
      </button>
      {quickBooksGrantUrl && (
        <div>
          <a href={quickBooksGrantUrl}>GRANT LINK READY</a>
        </div>
      )}
    </div>
  )
}
